module.exports = __webpack_public_path__ + "img/authy.d1db96d6.png";